/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Play = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Play"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      d="M18.207 10.586a1.658 1.658 0 0 1 0 2.828l-8.626 5.33C8.457 19.438 7 18.64 7 17.33V6.67c0-1.31 1.457-2.108 2.581-1.414z"
      className="SVG"
    />
  </svg>
);

export const PlayIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'play-icon'}
      icon={Play}
      {...props}
      size={size}
    />
  );
};
